/* eslint-disable array-callback-return */
import React, { Component } from 'react';
import __ from 'lodash';
import {connect} from 'react-redux';
import { CONFIG } from '../../../../config';
import accountManagement from '../../../../apis/accountManagement';
import LoaderModal from '../../../modal/LoaderModal';
import Loader from '../../../Loader';
import { Alert,Form,Row, Col, Card} from 'react-bootstrap';
import { MuiPickersUtilsProvider,KeyboardDateTimePicker } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import {List,ListItem,ListItemText, Switch} from '@material-ui/core';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import TextField from '@material-ui/core/TextField';
import history from '../../../../history';

class LearningForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            action: 'add',
            alertShow: false,
            isFetching: false,
            isLoading: false,
            resMessage: '',
            data: {},
            kelas: [],
            kelasParalel: [],
            kpSelected: [],
            mapel: [],
            bab: [],
            subbab: [],
            tematik: [],
            subTematik: [],
            pembTematik: [],
            isSave: false,
        };
    }

    async componentDidMount() {
        console.clear();
        console.time('LearningForm time');
        this.setState({
            isFetching:true
        })

        if(this.props.data !== null) {
            this.setState({
                data: this.props.data,
                action: 'edit'
            })

            this.getRencBelKelasParalel(this.props.data.idRencana);
            this.getKelasParalel(this.props.data.idKelas);
            /*
            this.getMapel(this.props.data.idKelas);
            this.getBab(this.props.data.idMapel);
            this.getSubBab(this.props.data.idBab);
            */
        }
        this.setState({
            kpSelected:[]
        })
        this.getKelas();
        this.setState({
            isFetching: false
        })
        console.timeEnd('LearningForm time');
    }

    getRencBelKelasParalel = async(id) => {
        this.setState({
            isFetching: true
        })

        const res = await accountManagement.get(CONFIG.LEARNING_GET_RENCBEL_KLS_PARALEL + id)
        .catch(function(error) {
            console.error(error);
        })

        if(res) {
            if(res.data.code === "200") {
                this.setState({
                    kpSelected: res.data.data
                })
            }
            else {
                this.setState({
                    resMessage: res.data.errorSchema.errorMessage
                })
            }
            this.setState({
                isFetching: false
            });
        }
    }

    getKelas = async() => {
        this.setState({
            isFetching: true,
            kelas:[],
        })

        const res = await accountManagement.get(CONFIG.GET_KELAS_BY_GURU + this.props.idGuru)
        .catch(function(error) {
            console.error(error);
        })

        if(res) {
            if(res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    kelas: res.data.data
                })
            }
            else {
                this.setState({
                    resMessage: res.data.errorSchema.errorMessage
                })
            }
            this.setState({
                isFetching: false
            });
        }
    }

    getKelasParalel = async(idKelas) => {
        this.setState({
            isLoading: true
        })

        const response = await accountManagement.get(CONFIG.GURU_GET_KELASPARALEL_BY_KELAS + (idKelas === null ? 0 : idKelas))
        .catch (function(error) {
            console.error(error);
        })

        if(response) {
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    kelasParalel: response.data.data
                })
            }
            else {
                this.setState({
                    resMessage: response.data.errorSchema.errorMessage
                })
            }
            this.setState({
                isLoading: false
            });
        }

    }

    getMapel = async(id) => {
        this.setState({
            isFetching: true,
            mapel:[],
            bab:[],
            subbab:[]
        });

        const resMapel = await accountManagement.get(CONFIG.GURU_GET_MAPEL_BY_KELAS, {
            params: {idKelas: (id === null ? 0 : id) , idGuru: this.props.idGuru}
        }).catch(function(error) {
            console.error(error);
        })

        if(resMapel) {
            if(resMapel.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    mapel: resMapel.data.data,
                    data: {...this.state.data,
                        idKelas: id
                    }
                })
            }
            else {
                this.setState({
                    resMessage: resMapel.data.errorSchema.errorMessage
                })
            }
            this.setState({isFetching: false});
        }
    }

    getBab = async(id) => {
        this.setState({
            isFetching: true,
            bab: [],
            subbab: []
        });

        const res = await accountManagement.get(CONFIG.MAPEL_MANAGEMENT_GET_BAB + id)
        .catch(function(error) {
            console.error(error);
        })

        if(res) {
            if(res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    bab: res.data.data,
                    data: {...this.state.data,
                        idMapel: id,
                        idTematik: null
                    }
                })
            }
            else {
                this.setState({
                    resMessage: res.data.errorSchema.errorMessage
                })
            }
            this.setState({
                isFetching: false
            });
        }
    }

    getSubBab = async(id) => {
        this.setState({
            isFetching: true,
            subbab:[]
        });

        const res = await accountManagement.get(CONFIG.MAPEL_MANAGEMENT_GET_SUBBAB + id)
        .catch(function(error) {
            console.error(error);
        })

        if(res) {
            if(res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    subbab: res.data.data,
                    data: {...this.state.data,
                        idBab: id,
                        idSubTematik: null
                    }
                })
            }
            else {
                this.setState({
                    resMessage: res.data.errorSchema.errorMessage
                })
            }
            this.setState({
                isFetching: false
            });
        }
    }

    getTematik = async(id) => {
        this.setState({
            isFetching: true,
            tematik: [],
            subTematik: [],
            pembTematik: []
        });

        const res = await accountManagement.get(CONFIG.MAPEL_MANAGEMENT_FETCH_TEMATIK_BY_ID_KELAS, {
            params: {idKelas: (id === null ? 0 : id)}
        }).catch(function(error) {
            console.error(error);
        })

        if(res) {
            if(res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    tematik: res.data.data,
                    data: {...this.state.data,
                        idKelas: id
                    }
                })
            }
            else {
                this.setState({
                    resMessage: res.data.errorSchema.errorMessage
                })
            }
            this.setState({
                isFetching: false
            });
        }
    }

    getSubTematik = async(id) => {
        this.setState({
            isFetching: true,
            subTematik:[],
            pembTematik:[]
        });

        const res = await accountManagement.get(CONFIG.MAPEL_MANAGEMENT_GET_SUBTEMA, {
            params: {idTematik: (id === null ? 0 : id)}
        }).catch(function(error) {
            console.error(error);
        })

        if(res) {
            if(res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    subTematik: res.data.data,
                    data: {...this.state.data,
                        idTematik: id,
                        idMapel: null
                    }
                })
            }
            else {
                this.setState({
                    resMessage: res.data.errorSchema.errorMessage
                })
            }
            this.setState({
                isFetching: false
            });
        }
    }

    getPembTematik = async(id) => {
        this.setState({
            isFetching: true,
            pembTematik: []
        });

        const res = await accountManagement.get(CONFIG.MAPEL_MANAGEMENT_GET_PEMBTEMA,
            {params: {idSubTematik: (id === null ? 0 : id)}
        }).catch(function(error) {
            console.error(error);
        })

        if(res) {
            if(res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    pembTematik: res.data.data,
                    data: {...this.state.data,
                        idSubTematik: id,
                        idBab: null
                    }
                })
            }
            else {
                this.setState({
                    resMessage: res.data.errorSchema.errorMessage
                })
            }

            this.setState({
                isFetching: false
            });
        }
    }

    onChangeKelas(e) {
        console.clear();
        console.info('onChangeKelas value =>', e.target.value);

        let id = e.target.value;
        this.setState({
            kelasParalel: [],
            data: {...this.state.data,
                idKelas: id
            }
        })

        if(id !== '') {
            this.getKelasParalel(id);
            this.getMapel(id);
            this.getTematik(id);
        }
    }

    onChangeKp(e) {
        console.clear();
        console.info('onChangeKp checked =>', e.target.checked);
        console.info('onChangeKp value =>', e.target.value);

        let isChecked = e.target.checked;
        let value = parseInt(e.target.value);
        const { kelasParalel, kpSelected } = this.state;

        if(isChecked) {
            kelasParalel.map(kp => {
                if (parseInt(kp.idKelasParalel) === value) {
                    this.setState(prevState => ({
                        kpSelected: [...prevState.kpSelected, kp]
                    }));
                }
            })
        }
        else {
            this.setState({
                kpSelected: kpSelected.filter(kp => parseInt(kp.idKelasParalel) !== value)
            });
        }
    }

    handleChange = (e) => {
        console.clear();
        console.info('handleChange value =>', e.target.value);

        let val = e.target.value;

        this.setState({
            data: {...this.state.data,
                judul: val
            }
        })
    }

    changeStartDate = (date) => {
        console.clear();
        console.info('changeStartDate =>', date);

        this.setState(prevState => ({
            data: {...prevState.data,
                startDate: date
            }
        }))
    }

    mapelOnChange(e) {
        let id = e.target.value;
        this.setState({
            subTematik:[],
            pembTematik:[],
            bab:[],
            subbab:[]
        })

        if(id !== '') {
            this.getBab(id);
        }
    }

    babOnChange(e) {
        let id = e.target.value;
        this.setState({
            pembTematik:[],
            subbab:[]
        })

        if(id !== '') {
            this.getSubBab(id);
        }
    }

    subBabOnChange(e) {
        let id = e.target.value;

        if(id !== '') {
            this.setState({
                data: {...this.state.data,
                    idSubBab: id,
                    idPembTematik: null
                }
            })
        }
    }

    temaOnChange(e) {
        let id = e.target.value;
        this.setState({
            subTematik:[],
            pembTematik:[],
            bab:[],
            subbab:[]
        })

        if(id !== '') {
            this.getSubTematik(id);
        }
    }

    subTemaOnChange(e) {
        let id = e.target.value;

        this.setState({
            pembTematik:[],
            subbab:[]
        })

        if(id !== '') {
            this.getPembTematik(id);
        }
    }

    pembTemaOnChange(e) {
        console.clear();
        let id = e.target.value;

        if(id !== '') {
            this.setState({
                data: {...this.state.data,
                    idSubBab: null,
                    idPembTematik: id
                }
            })
        }
    }

    renderKelas() {
        const { kelas, data } = this.state;

        if(!__.isEmpty(kelas)) {
            return kelas.map((kel, indexKelas) => {
                return (<option key={indexKelas} value={kel.ID_KELAS}>{kel.NAMA_KELAS}</option>)

                /*
                if(parseInt(data.idKelas) === kel.ID_KELAS) {
                    return ( <option key={indexKelas} value={kel.ID_KELAS} selected>{kel.NAMA_KELAS}</option> )
                }
                else {
                    return ( <option key={indexKelas} value={kel.ID_KELAS}>{kel.NAMA_KELAS}</option> )
                }
                */
            })
        }
    }

    renderKpCheck(idKelasParalel) {
        let elem = <Switch color="secondary" value={idKelasParalel || ''} onChange={e => this.onChangeKp(e)} checked={false}/>;

        this.state.kpSelected.map( item => {
            if(parseInt(item.idKelasParalel) === idKelasParalel) {
                elem = <Switch color="secondary" value={idKelasParalel || ''} onChange={e => this.onChangeKp(e)} checked={true}/>;
            }
        })
        return elem;
    }

    renderMapel() {
        let { mapel, data } = this.state;

        if(!__.isEmpty(mapel)) {
            return mapel.map((m) => {
                if(parseInt(data.idMapel) === m.idMataPelajaran) {
                    return ( <option value={m.idMataPelajaran} selected>{m.namaMataPelajaran}</option> )
                }
                else {
                    return ( <option value={m.idMataPelajaran}>{m.namaMataPelajaran}</option> )
                }
            })
        }
    }

    renderBab() {
        let { bab, data } = this.state;

        if(!__.isEmpty(bab)) {
            return bab.map((item) => {
                if(parseInt(data.idBab) === item.idBab) {
                    return ( <option value={item.idBab} selected>{item.namaBab}</option> )
                }
                else {
                    return ( <option value={item.idBab}>{item.namaBab}</option> )
                }
            })
        }
    }

    renderSubBab() {
        let { subbab, data } = this.state;

        if(!__.isEmpty(subbab)) {
            return subbab.map((item) => {
                if(parseInt(data.idSubBab) === item.idSubBab) {
                    return ( <option value={item.idSubBab} selected>{item.namaSubBab}</option> )
                }
                else {
                    return ( <option value={item.idSubBab} >{item.namaSubBab}</option> )
                }
            })
        }
    }

    handleBack() {
        this.props.handleBack();
    }

    handleSubmit = async(e) => {
        e.preventDefault();
        console.clear();
        console.groupCollapsed('Handle Submit');
        console.info('action', this.state.action);
        console.info('data', this.state.data);
        console.info('kpSelected', this.state.kpSelected);
        console.groupEnd();

        let { action, data, kpSelected } = this.state;
        this.setState({
            isFetching: true
        });

        /*
        if(this.state.data.idSubBab == null && this.state.data.idPembTematik == null) {
            this.setState({
                alertShow:true,
                isFetching: false,
                resMessage: 'Silakan Pilih Sub Bab atau Pemb Tematik'
            })
            return false;
        }
        */

        if(action === 'add') {
            const sequence = await accountManagement.get(CONFIG.LEARNING_RENC_BELAJAR_SEQ)
            .catch(function(error) {
                console.error(error);
            })

            if(sequence) {
                data = {...data,
                    ['idKelas']: this.state.data.idKelas,
                    ['sequence']: sequence.data.data,
                    ['idSekolah']: this.props.idSekolah,
                    ['idGuru']: this.props.idGuru,
                    ['idRencana']: sequence.data.data,
                    ['idKelasParalel']: kpSelected.map(v => v.idKelasParalel),
                    ['startDate']: document.getElementById("startDate").value
                }

                const res = await accountManagement.post(CONFIG.LEARNING_POST_RENC_BELAJAR, data)
                .catch(function(error) {
                    console.error('Action Add Error', error);
                });

                if(res) {
                    console.info('Response Action Add', res.data);
                    if(res.data.code === "200") {
                        history.push({
                            pathname: '/learning_konten/SOAL/',
                            state: data
                        })
                    }
                    else {
                        this.setState({
                            resMessage: res.data.msg,
                            isFetching: false
                        });
                    }
                }
            }
        }
        else if(action === 'edit') {
            data = {...data,
                ['idSekolah']: this.props.idSekolah,
                ['idGuru']: this.props.idGuru,
                ['idKelasParalel']: kpSelected.map(v => v.idKelasParalel),
                ['startDate']: document.getElementById("startDate").value,
            }

            const res = await accountManagement.post(CONFIG.LEARNING_POST_EDIT_RENC_BELAJAR, data)
            .catch(function(error) {
                console.error('Action Edit Error', error);
            })

            if(res) {
                console.info('Response Action Edit', res.data);
                if(res.data.code === "200") {
                    if(this.state.isSave) {
                        this.handleBack();
                    }
                    else {
                        // window.location.pathname = '/learning_konten/SOAL/' + this.state.idSubBab +'/'+ data.idRencana;
                        history.push({
                            pathname: '/learning_konten/SOAL/',
                            state: data
                        })
                    }
                }
                else {
                    this.setState({
                        resMessage: res.data.msg,
                        isFetching: false
                    });
                }
            }
        }
    }

    render() {
        console.groupCollapsed('This Render LearningForm Cek State/Props');
        console.info('State', this.state);
        console.info('Props', this.props);
        console.groupEnd();

        const { action, data, kelasParalel } = this.state;
        let pageTitle;

        if(action === 'add') {
            pageTitle = 'Tambah Learning';
        }
        else {
            pageTitle = 'Edit Learning ' + data.judul;
        }

        return (
            <div>
                <LoaderModal isFetching={this.state.isFetching}/>
                {this.loadAlert()}
                <h4>{pageTitle}</h4>
                <Form onSubmit={this.handleSubmit}>
                    <Row>
                        <Col>
                            <Form.Group controlId="judul">
                                <TextField required id="standard-required" label="Judul"
                                    value={data.judul === undefined ? '' : data.judul}
                                    onInput = {(e) => {
                                        e.target.value = e.target.value.toString().slice(0,100)
                                    }}
                                    onChange={(e) => this.handleChange(e)}
                                />
                                {/*
                                <Form.Label>Judul : </Form.Label>
                                <Form.Control type="text" name="judul" placeholder="Input Judul..." defaultValue={data.judul} maxlength="100" required/>
                                */}
                            </Form.Group>
                        </Col>

                        <Col>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDateTimePicker
                                    name="startDate"
                                    id="startDate"
                                    value={data.startDate}
                                    onChange={this.changeStartDate}
                                    label="Start Date"
                                    ampm={false}
                                    format="dd-MM-yyyy HH:mm" required
                                />
                            </MuiPickersUtilsProvider>
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={6}>
                            <Form.Group controlId="kelas">
                                <Form.Label>Kelas :</Form.Label>
                                {/* <select className="form-control" name="kelas" defaultValue={""} onChange={(e) => this.onChangeKelas(e)} required> */}
                                <select className="form-control" name="kelas" value={data.idKelas} onChange={(e) => this.onChangeKelas(e)} required>
                                    <option value="">Pilih Kelas...</option>
                                    {this.renderKelas()}
                                </select>
                            </Form.Group>
                        </Col>

                        { this.state.isLoading ?
                            <Loader/>
                            :
                            <Col sm={6} style={ kelasParalel.length === 0 ? { display: 'none' } : {}}>
                                <Form.Group controlId="kelasParalel">
                                    <Form.Label>Kelas Paralel :</Form.Label>
                                    <List>
                                        { kelasParalel.map((kp,i) =>
                                            <Card key={i} style={{ marginBottom:'5px' }}>
                                                <Row>
                                                    <Col sm={10}>
                                                        <ListItem>
                                                            <span style={{ color: 'DodgerBlue' }}>
                                                                <i className="fa fa-folder-o" aria-hidden="true"></i>
                                                            </span>

                                                            <ListItemText inset primary={kp.namaKelasParalel} />
                                                        </ListItem>
                                                    </Col>

                                                    <Col className="text-right" style={{ margin: 'auto' }}>
                                                        {this.renderKpCheck(kp.idKelasParalel)}
                                                    </Col>
                                                </Row>
                                            </Card>
                                        )}
                                    </List>
                                </Form.Group>
                            </Col>
                        }
                    </Row>

                    {/*
                    <Form.Group>
                        <>
                            <ul className="nav nav-tabs">
                                <li className="nav-item">
                                    <a className="nav-link active" data-toggle="tab" href="#one">Mata Pelajaran</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-toggle="tab" href="#two">Tematik</a>
                                </li>
                            </ul>


                            <div className="tab-content" style={{ marginTop: '1em' }}>
                                <div className="tab-pane active" id="one">
                                    <Row >
                                        <Col>
                                            <Form.Group controlId="mapel">
                                                <select className="form-control" name="mapel" de onChange={e => this.mapelOnChange(e)}>
                                                    <option value="">Pilih Mata Pelajaran...</option>
                                                    {this.renderMapel()}
                                                </select>
                                            </Form.Group>
                                        </Col>

                                        <Col>
                                            <Form.Group controlId="bab">
                                                <select className="form-control" name="bab" onChange={(e) => this.babOnChange(e)}>
                                                    <option value="">Pilih Bab...</option>
                                                    {this.renderBab()}
                                                </select>
                                            </Form.Group>
                                        </Col>

                                        <Col>
                                            <Form.Group controlId="subBab">
                                                <select className="form-control" name="subBab" onChange={(e) => this.subBabOnChange(e)}>
                                                    <option value="">Pilih Sub Bab...</option>
                                                    {this.renderSubBab()}
                                                </select>
                                            </Form.Group>
                                        </Col>

                                    </Row>

                                </div>

                                <div className="tab-pane" id="two">
                                    <Row >
                                        <Col>
                                            <Form.Group controlId="tema">
                                                <select className="form-control" name="tema" value={data.idTematik} onChange={(e) => this.temaOnChange(e)}>
                                                    <option value="">Pilih Tematik...</option>
                                                    { this.state.tematik.map((data,i) =>
                                                        <option value={data.idTematik}>{data.namaTematik}</option>
                                                    )}
                                                </select>
                                            </Form.Group>
                                        </Col>

                                        <Col>
                                            <Form.Group controlId="subTema">
                                                <select className="form-control" name="subTema" value={data.idSubTematik} onChange={(e) => this.subTemaOnChange(e)}>
                                                    <option value="">Pilih Sub Tematik...</option>
                                                    { this.state.subTematik.map((data,i) =>
                                                        <option value={data.idSubTematik}>{data.namaSubTematik}</option>
                                                    )}
                                                </select>
                                            </Form.Group>
                                        </Col>

                                        <Col>
                                            <Form.Group controlId="pembTema">
                                                <select className="form-control" name="pembTema" value={data.idPembTematik} onChange={(e) => this.pembTemaOnChange(e)}>
                                                    <option value="">Pilih Pembelajaran Tematik...</option>
                                                    { this.state.pembTematik.map((data,i) =>
                                                        <option value={data.idPembTematik}>{data.namaPembTematik}</option>
                                                    )}
                                                </select>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </>
                    </Form.Group>
                    */}

                    <Form.Group>
                        <button type="button" className="btn btn-danger" onClick={() => this.handleBack()}>
                            <ArrowBackIosIcon fontSize="small"/>Cancel
                        </button>

                        { this.state.action === 'add' ?
                            <button type="submit" className="btn btn-primary pull-right">
                                Next <ArrowForwardIosIcon fontSize="small"/>
                            </button>
                            :
                            <div className="pull-right">
                                <button type="submit" className="btn btn-success" style={{width: '90px'}} onClick={ e => this.setState({isSave: true}) }>
                                    Save
                                </button>
                                &nbsp;&nbsp;
                                <button type="submit" className="btn btn-primary" onClick={ e => this.setState({isSave: false}) }>
                                    Next <ArrowForwardIosIcon fontSize="small"/>
                                </button>
                            </div>
                        }
                    </Form.Group>
                </Form>
            </div>
        );
    }

    loading = () => {
        if(this.state.isLoading) {
            return(
                <Loader />
            )
        }
    }

    loadAlert = () => {
        const { alertShow } = this.state;

        if (alertShow) {
            return (
                <Alert variant="info" onClose={() => this.setState({ alertShow: false })} dismissible>
                    <strong>{this.state.resMessage}</strong>
                </Alert>
            );
        }
    }
}

const mapStateToProps = (state) => {
    return{
        account: state.account
    };
}

export default connect(mapStateToProps)(LearningForm);